<template>
    <button class="button" :class="{ 'is-selected': isSelected }">
        <div class="default">
            <span class="icon"><slot /></span>
            <span v-html="data.label" class="label"></span>
        </div>
        <span class="hover">
            <span class="icon"><slot /></span>
            <span v-html="data.hover" class="label"></span>
        </span>
    </button>
</template>
<script>
export default
{
    props:
    {
        data:
        {
            type: Object
        },

        isSelected:
        {
            type: Boolean,
            default: false
        }
    }
}
</script>
<style lang="sass" scoped>
@import "../../style/_settings/__index.sass"
@import "../../style/_required/_index.sass"

.button
    text-align: center
    position: relative
    padding: 2vh
    border-radius: 20px
    display: flex
    justify-content: center
    background: #FFF

    *
        vertical-align: middle

    &:before
        content: ""
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 100%
        opacity: 0
        background: map-get($colors, "blue")
        border-radius: 20px
        transition: opacity 0.5s
        will-change: opacity

    &.is-selected:before
        opacity: 1

.default
    @extend %font-regular
    +font-size(18px)
    transition: opacity 0.5s
    will-change: opacity
    display: flex
    justify-content: center

    .is-selected &
        opacity: 0

.icon
    margin-right: 1em
    display: flex
    align-items: center

.hover
    @extend %font-semibold
    +font-size(12px)
    text-transform: uppercase
    position: absolute
    top: 50%
    left: 0
    width: 100%
    opacity: 0
    transform: translateY(-50%)
    color: #FFF
    transition: opacity 0.5s
    will-change: opacity
    display: flex
    justify-content: center

    .icon
        filter: brightness(0) invert(1)

    .is-selected &
        opacity: 1

@media screen and (max-width: 1280px)
    .button
        padding: 1.2vw 0.7vw

@media screen and (max-width: 960px)
    .button
        padding: 15px 6px
        line-height: 1em

    .default
        +font-size(14px)

    .hover
        +font-size(12px)

    .icon
        margin-right: 0.5em

@media screen and (max-width: 640px)
    .button
        padding: 12px 6px
        line-height: 1em

    .default
        +font-size(13px)

    .hover
        +font-size(11px)

@media screen and (max-width: 420px)
    .button
        padding: 6px 6px
        line-height: 0.8em

    .default
        +font-size(12px)

        .icon
            position: absolute
            top: -12px
            left: 12px

    .hover
        +font-size(10px)

        .icon
            display: none

</style>
